export type ShippingBadgeProps = {
  isShippingSameDay: boolean
  isShippingSameDayAndFree: boolean
}

const ShippingBadge = ({
  isShippingSameDay,
  isShippingSameDayAndFree,
}: ShippingBadgeProps) => {
  if (!isShippingSameDay) {
    return <div data-fs-product-shipping__badge-empty />
  }

  return (
    <div data-fs-product-shipping__badge>
      <p>{isShippingSameDayAndFree ? 'Recibilo gratis hoy' : 'Recibilo hoy'}</p>
    </div>
  )
}

export default ShippingBadge
